import { MiniappSdkContext } from 'components/miniapp-sdk-provider/miniapp-sdk.context';
import { getMiniappSdkClient } from 'components/miniapp-sdk-provider/miniapp-sdk.hooks';
import { useSelector } from 'react-redux';
import { uiMetadata } from 'store/ui-metadata/selectors';

import React from 'react';

interface MiniappSdkProviderProps {
  children: React.ReactNode;
}

export const MiniappSdkProvider = ({ children }: MiniappSdkProviderProps): JSX.Element => {
  const UiMetadata = useSelector(uiMetadata);
  const appUuid = UiMetadata?.app_uuid;
  const miniappSdkClient = getMiniappSdkClient(appUuid);

  return <MiniappSdkContext.Provider value={miniappSdkClient}>{children}</MiniappSdkContext.Provider>;
};
